import {createSelector} from 'reselect';

import {findConfiguration} from '../../utils/configuration';
import type {RootState} from '../reducers';
import {AppState} from './types';

const appSelectors = {
  getApp: createSelector(
    [(state: RootState) => state.app],
    (app: AppState) => app
  ),
  getSoundMuteMode: createSelector(
    [(state: RootState) => state.app],
    (app: AppState) => {
      if (app.printTheme) {
        return false;
      }
      if (app.myConfigurations) {
        const soundConfig = findConfiguration(
          app.myConfigurations,
          'global',
          'sound'
        );
        if (soundConfig) {
          return soundConfig.value !== '1';
        }
      }
      return false;
    }
  ),
  getIsDarkMode: createSelector(
    [(state: RootState) => state.app],
    (app: AppState) => {
      if (app.printTheme) {
        return false;
      }
      if (app.myConfigurations) {
        const themeConfig = findConfiguration(
          app.myConfigurations,
          'global',
          'theme'
        );
        if (themeConfig) {
          return themeConfig.value !== 'light';
        }
      }
      return true;
    }
  ),
  getIsCompactMode: createSelector([(state: RootState) => state.app], () => {
    return true;
  }),
  getControlRoomIsMonitored: createSelector(
    [(state: RootState) => state.app],
    (app: AppState) => {
      if (app.printTheme) {
        return false;
      }
      if (app.myConfigurations) {
        const value = findConfiguration(
          app.myConfigurations,
          'global',
          'control_room_is_monitored'
        );

        return value ?? true;
      }
      return true;
    }
  ),
};

export const backendSelectors = {
  getBackend: (state: RootState) => state.backend.backend,
  getLicense: (state: RootState) => state.backend.backend?.license,
  getBlastMode: (state: RootState) => state.backend.blastMode,
  getMessages: (state: RootState) => state.backend.backend?.messages,
};

export default appSelectors;
